import {RestartAlt} from '@mui/icons-material'
import {Button, useMediaQuery, useTheme} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

interface ResetMaterialVariationsButtonProps {
  onReset: () => void
  testId?: string
  variant?: 'responsive' | 'fixed'
}

export const ResetMaterialVariationsButton: React.FC<ResetMaterialVariationsButtonProps> = ({
  onReset,
  testId = 'reset-material-variations-button',
  variant = 'responsive'
}) => {
  const {t} = useTranslation()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const baseStyles = {
    textTransform: 'none' as const,
    fontWeight: 500,
    lineHeight: '24px',
    borderColor: '#E8ECF0',
    color: '#29333D',
    backgroundColor: '#FFFFFF',
    fontFamily: 'Inter',
    '&:hover': {
      backgroundColor: '#F5F7F9',
      borderColor: '#D1D9E0'
    },
    '&:active': {
      backgroundColor: '#E6EEF5',
      borderColor: '#C1CDD9'
    }
  }

  const responsiveStyles =
    variant === 'responsive'
      ? {
          '@media (max-width: 320px)': {
            fontSize: '13px',
            padding: '8px 16px',
            minHeight: '40px'
          },
          '@media (max-width: 240px)': {
            fontSize: '10px',
            padding: '4px 8px',
            minHeight: '32px'
          }
        }
      : {}

  const fixedStyles =
    variant === 'fixed'
      ? {
          height: '48px',
          fontSize: '16px'
        }
      : {}

  return (
    <Button
      variant="outlined"
      onClick={onReset}
      startIcon={<RestartAlt />}
      fullWidth
      size={variant === 'responsive' && isSmallScreen ? 'small' : 'medium'}
      sx={{
        ...baseStyles,
        ...fixedStyles,
        ...responsiveStyles
      }}
      data-test-id={testId}
    >
      {t('orderIntake.materialVariations.resetToDefaultValues')}
    </Button>
  )
}
